import { gql } from "@apollo/client";

export const GET_LOGIN = gql`
    query MyQuery {
        queryUser(
            filter: {
                username: { allofterms: "agent" }
                password: { allofterms: "1234" }
            }
        ) {
            role
            id
        }
    }
`;
export const GET_BUILDER_DATA = gql`
    query MyQuery($id: [ID!]) {
        queryItinerary(filter: { id: $id }) {
            id
        }
    }
`;
export const VACATION_TYPE_QUESTION = gql`
    query MyQuery($key: StringTermFilter = { allofterms: "tripOccasion" }) {
        queryTravelQuestion(
            filter: { key: $key, type: { eq: WorldExploration } }
        ) {
            defaultValue
            answerChoices {
                id
                sortOrder
                tooltip
                isAlwaysSelected
                displayRow
                value
            }
        }
    }
`;
export const BUDGET_QUESTION = gql`
    query MyQuery($key: StringTermFilter = { allofterms: "tripBudget" }) {
        queryTravelQuestion(
            filter: { key: $key, type: { eq: WorldExploration } }
        ) {
            defaultValue
            answerChoices {
                id
                sortOrder
                tooltip
                isAlwaysSelected
                displayRow
                value
            }
        }
    }
`;
export const GET_ANSWERS = gql`
    query MyQuery($key: String) {
        queryTravelAnswer(filter: { key: { anyofterms: $key } }) {
            id
            key
            name
            phone
            sharedEmails
            email
            from
            destination
            startDate
            endDate
            adultsCount
            kidsCount
            budget
            vacationType
            interests
            amenities
            roomRequirement
            resortRquirements
            importantInfo
            previouslyStayedResortInfo
            comment
            tours
            cities
            attractions
            stayRequirements
            submitTime
            summary
        }
    }
`;

export const GET_ITINERARY_FULL = gql`query MyQuery($key: String) {
    queryItinerary(filter: {key: {allofterms: $key}}) {
        id
        key
        startDate
        endDate
        isPackagePrice
        tourOperator
        tourOperatorConfirmationNumber
        name
        type
        description
        tripOverview
        customUrls {
            id
            name
            url
        }
        travelAnswer{
            id
            key
            name
            phone
            email
            sharedEmails
            from
            destination
            startDate
            endDate
            adultsCount
            kidsCount
            budget
            vacationType
            interests
            amenities
            roomRequirement
            resortRquirements
            importantInfo
            previouslyStayedResortInfo
            comment
            tours
            cities
            attractions
            stayRequirements
            submitTime
            summary
        }
        tripAdvisoryConfirmation {
            id
            name
            url
        }
        media(filter: {not: {isDeleted: true}}) {
            id
            url
            displayName
        }
        persons(filter: {not: {isDeleted: true}}) {
            id
            firstname
            lastname
            dateOfBirth
        }
        tripAdvisory {
            id
            displayName
            url
        }
        healthAdvisory {
            id
            url
        }
        emergencyContacts {
            email
            id
            name
            phone
            comment
        }
        importantInformations {
            id
            contact
            email
            information
            type
        }
        comment
        submitTime
        parentRef{
            key
            id
            key
            name
        }
        shares{
            id
            name
        }
        cloneRef{
            id
            key
            name
        }
        days(filter: {not: {isDeleted: true}}, order: {asc: date}) {
            id
            date
            stayPoint
            importantInformation
            details
            cancellationPolicy
            internalComment
            confirmations(filter: {not: {isDeleted: true }}) {
                id
                url
                name
            }
            media(filter: {not: {isDeleted: true }}) {
                id
                url
                displayName
            }
            contacts {
                id
                name
                email
                phone
            }
            dayAdditionalInformation(filter: {not: {isDeleted: true}}) {
                id
                tittle
                time
                description
            }
            dayAccommodations(filter: {not: {isDeleted: true}}) {
                id
                bookedDays
                cancellationPolicy
                checkInDate
                checkInTime
                checkOutDate
                checkOutTime
                comment
                confirmationNumber
                extraRequest
                guestNames
                isVisible
                persons {
                    id
                    dateOfBirth
                    firstname
                    lastname
                }
                netPrice
                bookingStatus
                accommodationFlights(filter: {not: {isDeleted: true}}) {
                    id
                    flight {
                        airlineName
                        arrivalAirport
                        departure {
                            id
                            timeZone
                            airportCode
                        }
                        arrival {
                            id
                            timeZone
                            airportCode
                        }
                        arrivalAirportCode
                        comments
                        departureAirport
                        departureAirportCode
                        flgithNumber
                        flightOperatedByAirline
                        flightOperatedByFlightNbr
                        id
                    }
                }
                benchmarkPrice
                packagePrice
                payNow
                seaparatePrice
                publishedPrice
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                accommodation {
                    id
                    street
                    street2
                    type
                    locality
                    adultsOnly
                    website
                    city
                    description
                    numberOfStars
                    rating
                    country
                    email
                    name
                    phone
                    stateProvince
                    zip
                    media {
                        id
                        url
                        displayName
                    }
                    amenities {
                        type
                        image
                        comment
                    }
                    roomDetails(filter: {not: {isDeleted: true}, has: name}) {
                        id
                        beds
                        name
                        size
                        media(filter: {not: {isDeleted: true}}) {
                            id
                            displayName
                            url
                        }
                        roomAmenities(filter: {not: {isDeleted: true}}) {
                            type
                            image
                            comment
                        }
                    }
                    checkInTime
                    checkOutTime
                    street
                    street2
                    city
                    stateProvince
                    zip
                    country
                    expediaPropertyId
                    expediaLocationId
                    provider
                }
                accommodationRoom {
                    id
                    beds
                    comment
                    maxOccupancy
                    name
                    size
                    media {
                        id
                        url
                    }
                }
                accommodationRooms {
                    id
                    beds
                    comment
                    maxOccupancy
                    name
                    size
                    media {
                        id
                        url
                    }
                    roomAmenities {
                        id
                        image
                        type
                    }
                }
                roomDetails {
                    count
                    id
                    price
                    checked
                    comment
                    roomDetail {
                        id
                        beds
                        comment
                        maxOccupancy
                        name
                        size
                        media {
                            id
                            url
                        }
                        roomAmenities{
                            id
                            image
                            type
                        }  
                    }
                }
            }
            dayActivities(filter: {not: {isDeleted: true}}) {
                id
                isVisible
                cancellationPolicy
                children
                adults
                comment
                confirmationNumber
                persons {
                    id
                    dateOfBirth
                    firstname
                    lastname
                }
                date
                dateOfBooking
                durationHours
                netPrice
                payNow
                participants
                bookingStatus
                publishedPrice
                isAddToSuggession
                startPoint
                meetingPointInfo
                startTime
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                activity {
                    id
                    name
                    description
                    comment
                    groupType
                    provider
                    type
                    media {
                        id
                        url
                        displayName
                    }
                }
                paymentRecords {
                    paymentId
                    paymentDate
                    title
                    description
                    type
                    cardToken
                    amount
                }
            }
            dayFlights(filter: {not: {isDeleted: true}}) {
                adults
                isVisible
                arrivalDate
                arrivalTime
                cabinType
                children
                cancellationPolicy
                comment
                price
                dateOfBooking
                bookingStatus
                departDate
                departTime
                flightCabinType
                id
                netPrice
                publishedPrice
                connectionFlightOrder
                connectionFlights {
                    adults
                    isVisible
                    arrivalDate
                    arrivalTime
                    cabinType
                    children
                    cancellationPolicy
                    comment
                    price
                    dateOfBooking
                    bookingStatus
                    departDate
                    departTime
                    flightCabinType
                    id
                    netPrice
                    publishedPrice
                    connectionFlightOrder
                    flight {
                        airlineName
                        arrivalAirport
                        departure {
                            id
                            timeZone
                            airportCode
                        }
                        arrival {
                            id
                            timeZone
                            airportCode
                        }
                        arrivalAirportCode
                        comments
                        departureAirport
                        departureAirportCode
                        flgithNumber
                        logo {
                            displayName
                            id
                            keywords
                            type
                            url
                        }
                        flightOperatedByAirline
                        flightOperatedByFlightNbr
                        id
                    }
                    confirmations(filter: {not: {isDeleted: true }}) {
                        id
                        name
                        url
                    }
                    recordLocator
                    operatedByAirlineRecordLocator
                }
                returnItineraryFlight {
                    adults
                    isVisible
                    arrivalDate
                    arrivalTime
                    cabinType
                    children
                    cancellationPolicy
                    comment
                    price
                    dateOfBooking
                    bookingStatus
                    departDate
                    departTime
                    flightCabinType
                    id
                    netPrice
                    publishedPrice
                    connectionFlightOrder
                    flight {
                        airlineName
                        arrivalAirport
                        departure {
                            id
                            timeZone
                            airportCode
                        }
                        arrival {
                            id
                            timeZone
                            airportCode
                        }
                        arrivalAirportCode
                        comments
                        departureAirport
                        departureAirportCode
                        flgithNumber
                        logo {
                            displayName
                            id
                            keywords
                            type
                            url
                        }
                        flightOperatedByAirline
                        flightOperatedByFlightNbr
                        id
                    }
                    confirmations(filter: {not: {isDeleted: true }}) {
                        id
                        name
                        url
                    }
                    recordLocator
                    operatedByAirlineRecordLocator
                    connectionFlights {
                        adults
                        isVisible
                        arrivalDate
                        arrivalTime
                        cabinType
                        children
                        cancellationPolicy
                        comment
                        price
                        dateOfBooking
                        bookingStatus
                        departDate
                        departTime
                        flightCabinType
                        id
                        netPrice
                        publishedPrice
                        connectionFlightOrder
                        flight {
                            airlineName
                            arrivalAirport
                            departure {
                                id
                                timeZone
                                airportCode
                            }
                            arrival {
                                id
                                timeZone
                                airportCode
                            }
                            arrivalAirportCode
                            comments
                            departureAirport
                            departureAirportCode
                            flgithNumber
                            logo {
                                displayName
                                id
                                keywords
                                type
                                url
                            }
                            flightOperatedByAirline
                            flightOperatedByFlightNbr
                            id
                        }
                        confirmations(filter: {not: {isDeleted: true }}) {
                            id
                            name
                            url
                        }
                        recordLocator
                        operatedByAirlineRecordLocator
                    }
                }
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                recordLocator
                operatedByAirlineRecordLocator
                flight {
                    airlineName
                    arrivalAirport
                    departure {
                        id
                        timeZone
                        airportCode
                    }
                    arrival {
                        id
                        timeZone
                        airportCode
                    }
                    arrivalAirportCode
                    comments
                    departureAirport
                    departureAirportCode
                    flgithNumber
                    logo {
                        displayName
                        id
                        keywords
                        type
                        url
                    }
                    flightOperatedByAirline
                    flightOperatedByFlightNbr
                    id
                }
            }
            dayTransfers(filter: {not: {isDeleted: true}}) {
                isVisible
                adults
                bookingDate
                children
                comment
                finishPoint
                bookingStatus
                id
                netPrice
                price
                cancellationPolicy
                providerConfirmationNumber
                publishedPrice
                payNow
                startPoint
                startTime
                transferDate
                type
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                transfer {
                    id
                    locality
                    providerEmail
                    providerName
                    providerPhone
                }
            }
            dayInsurances(filter: {not: {isDeleted: true}}) {
                id
                comment
                confirmationPolicyNumber
                netPrice
                cancellationPolicy
                policyDocument
                bookingStatus
                publishedPrice
                tripCost
                address
                effectiveDate
                departureDate
                returnDate
                depositDate
                payNow
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                insurance {
                    id
                    provider
                    plan
                    state
                }
                insuredPersons {
                    id
                    dateOfBirth
                    firstname
                    lastname
                }
            }
            dayCarRentals(filter: {not: {isDeleted: true}}) {
                isVisible
                publishedPrice
                payNow
                carRental {
                    companyName
                    media{
                        id
                        url
                    }
                }
                provider
                id
                cancellationPolicy
                dateOfBooking
                carType
                carBrand
                bookingStatus
                carAmenities
                pickUpLocation
                pickUpDate
                pickUpTime
                luggageCount
                doorCount
                passengerCount
                price
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                driver {
                    firstname
                    lastname
                }
                dropOffLocation
                dropOffDate
                dropOffTime
                payingArrangement
                comment
            }
            dayCruises(filter: {not: {isDeleted: true}}) {
                isVisible
                bookingStatus
                cancellationPolicy
                cabins {
                    beds
                    cabinCategory
                    cabinName
                    comment
                    id
                    maxOccupancy
                    roomAmenities
                    size
                    media {
                        displayName
                        id
                        keywords
                        type
                        url
                    }
                }
                cabin {
                    beds
                    cabinCategory
                    cabinName
                    comment
                    id
                    maxOccupancy
                    roomAmenities
                    size
                    media {
                        displayName
                        id
                        keywords
                        type
                        url
                    }
                }
                comment
                confirmationNumber
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                cruise {
                    comment
                    cruiseContactEmail
                    cruiseContactPhone
                    cruiseLineName
                    cruiseRouteName
                    departurePort
                    id
                    media {
                        displayName
                        id
                        keywords
                        type
                        url
                    }
                    logo{
                        displayName
                        id
                        keywords
                        type
                        url
                    }
                    numberOfNights
                    returnPort
                    shipName
                }
                cruiseDays
                deckNumber
                departureDate
                id
                netPrice
                numberOfAdults
                numberOfChildren
                persons {
                    dateOfBirth
                    firstname
                    id
                    lastname
                }
                publishedPrice
                request
                returnDate
                departureTime
                returnTime
            }
            daySeqNumber
            port
            timeAtPort
            description
            comment
            dayTrains(filter: {not: {isDeleted: true}}) {
                isVisible
                adults
                arrivalDate
                price
                arrivalTime
                carNumber
                children
                class
                bookingStatus
                comment
                dateOfBooking
                departDate
                departTime
                cancellationPolicy
                flexibility
                id
                netPrice
                publishedPrice
                seatNumber
                trainNumber
                trainType
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                train {
                    arrivalCity
                    arrivalTrainStation
                    comment
                    departureCity
                    departureTrailStation
                    id
                    trainCompany
                    trainTripName
                    logo{
                        url
                    }
                }
                persons {
                    dateOfBirth
                    firstname
                    id
                    lastname
                }
            }
            dayRestaurants(filter: {not: {isDeleted: true }}) {
                isVisible
                adults
                children
                bookingDate
                cancellationPolicy
                comment
                date
                bookingStatus
                durationHours
                isAddToSuggession
                id
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                reservationName
                startTime
                restaurant {
                    id
                    address
                    comment
                    cuisine
                    description
                    media {
                        id
                        displayName
                        url
                    }
                    name
                    phone
                    pricing
                    stars
                    website
                }
                media {
                    id
                    displayName
                    url
                }
            }
            dayFerries(filter: {not: {isDeleted: true}}) {
                isVisible
                adults
                arrivalDate
                arrivalTime
                children
                bookingStatus
                confirmationNumber
                cancellationPolicy
                class
                comment
                price
                confirmations(filter: {not: {isDeleted: true }}) {
                    id
                    name
                    url
                }
                dateOfBooking
                departDate
                departTime
                ferry {
                    arrivalPort
                    comment
                    logo {
                        displayName
                        id
                        keywords
                        type
                        url
                    }
                    departurePort
                    ferryCompany
                    id
                }
                flexibility
                id
                name
                netPrice
                persons {
                    dateOfBirth
                    firstname
                    id
                    lastname
                }
                publishedPrice
                payNow
                seatNumber
                shipType
                amenities {
                    comment
                    id
                    image
                    type
                }
            }
        }
    }
}`;
export const GET_USERPROFILE_DATA = gql`
    query MyQuery($email: String) {
        queryUserProfile(filter: { email: { allofterms: $email } }) {
            id
            firstName
            lastName
            phone
            email
            dateCreated
            picture {
                id
                url
            }
            wishList {
                id
                key
                name
                startDate
                endDate
                media {
                    id
                    url
                }
                travelAnswer {
                    id
                }
            }
        }
    }
`;

export const GET_PERSONAL_DATA = gql`
    query MyQuery($email: String) {
        queryTravelAnswer(
            order: { desc: submitTime }
            filter: {
                email: { allofterms: $email }
                or: { sharedEmails: { allofterms: $email } }
            }
        ) {
            adultsCount
            amenities
            budget
            childrenAges
            comment
            destination
            email
            endDate
            from
            id
            importantInfo
            interests
            kidsCount
            lapChildrenCount
            name
            phone
            previouslyStayedResortInfo
            resortRquirements
            roomRequirement
            startDate
            submitTime
            tripDateFelxibility
            vacationType
            bookingItems
            tripDateFelxibility
            summary
            key
            itineraries {
                id
                key
                type
                startDate
                endDate
                name
                media {
                    id
                    url
                }
                travelAnswer {
                    id
                    key
                }
                days(order: { asc: date }) {
                    id
                    date
                    dayActivities {
                        id
                        isVisible
                        cancellationPolicy
                        children
                        adults
                        comment
                        confirmationNumber
                        persons {
                            id
                            dateOfBirth
                            firstname
                            lastname
                        }
                        date
                        dateOfBooking
                        durationHours
                        netPrice
                        payNow
                        participants
                        bookingStatus
                        publishedPrice
                        isAddToSuggession
                        startPoint
                        meetingPointInfo
                        startTime
                        confirmations(filter: { not: { isDeleted: true } }) {
                            id
                            name
                            url
                        }
                        activity {
                            id
                            name
                            description
                            comment
                            groupType
                            provider
                            type
                            media {
                                id
                                url
                                displayName
                            }
                        }
                        paymentRecords {
                            paymentId
                            paymentDate
                            title
                            description
                            type
                            cardToken
                            amount
                        }
                    }
                }
            }
        }
    }
`;

export const QUERY_ITINERARY_ACCOMODATION_BY_CONFIRMATION_NUMBER = gql`
    query MyQuery($confirmationNumber: String) {
        queryItineraryAccommodation(
            filter: { confirmationNumber: { regexp: $confirmationNumber } }
        ) {
            benchmarkPrice
            bookedDays
            cancellationPolicy
            checkInDate
            #checkInTime
            checkOutDate
            #checkOutTime
            componentStatus
            confirmationNumber
            #comment
            extraRequest
            guestNames
            id
            isDeleted
            #isVisible
            netPrice
            packagePrice
            #payDate
            # paymentRecords(filter: {not: {isDeleted: true}}) {
            #     amount
            #     cardToken
            #     description
            #     id
            #     paymentDate
            #     paymentId
            #     title
            # }
            confirmations {
                url
                name
            }
            bookingStatus
            publishedPrice
            persons(filter: { not: { isDeleted: true } }) {
                comment
                dateOfBirth
                firstname
                lastname
            }
            seaparatePrice
            roomDetails {
                count
                #comment
                price
                roomDetail(filter: { not: { isDeleted: true } }) {
                    beds
                    maxOccupancy
                    name
                    size
                }
                checked
            }
            accommodation(
                filter: {
                    not: { isDeleted: true }
                    and: { has: expediaPropertyId }
                }
            ) {
                amenities(filter: { not: { isDeleted: true } }) {
                    type
                    image
                    comment
                }
                cancellationPolicy
                #checkInTime
                #checkOutTime
                city
                description
                email
                expediaLocationId
                expediaPropertyId
                id
                isDeleted
                locality
                numberOfStars
                phone
                #provider
                stateProvince
                street
                street2
                website
                zip
                adultsOnly
                media(
                    filter: { not: { isDeleted: true, and: { has: type } } }
                ) {
                    url
                    type
                    keywords
                    displayName
                }
                country
                rating
                type
                name
                roomDetails(filter: { not: { isDeleted: true } }) {
                    beds
                    #comment
                    media(filter: { not: { isDeleted: true } }) {
                        displayName
                        keywords
                        type
                        url
                    }
                    name
                    size
                    roomAmenities(filter: { not: { isDeleted: true } }) {
                        comment
                        image
                        type
                    }
                }
            }
            itineraryDay {
                contacts {
                    name
                    phone
                }
                daySeqNumber
                date
                internalComment
                itinerary {
                    travelAnswer {
                        email
                        phone
                        from
                        endDate
                        sharedEmails
                    }
                    name
                    key
                    type
                }
            }
        }
    }
`;
